import styled from "styled-components";
import {MinimumGamblingAgeIconDefaultBox} from "../../../boxes/icon/minimum-gambling-age-icon.default.box";

export const SwedenMinimumGamblingAgeIconBox = styled(MinimumGamblingAgeIconDefaultBox)<{isShownInHeader: boolean}>`
  height: ${props => props.isShownInHeader === true ? "2.5rem" : "23px"};
  width: ${props => props.isShownInHeader === true ? "auto" : "35px"};
`